import React, {useState} from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import Button from '#components/a/Button'
import ChatSubmitMessageIcon from '#components/svg/icons/ChatSubmitMessage'
import ChatInput from '#components/a/form/ChatInput'

function ChatMessageInputField({submitMessage, isSubmitting}) {
  const [chatInput, setChatInput] = useState('')

  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      callSubmitMessage()
    }
  }

  const handleClick = () => {
    callSubmitMessage()
  }

  const callSubmitMessage = () => {
    submitMessage(chatInput).then(success => success && setChatInput(''))
  }

  const chatInputIsEmpty = chatInput.trim().length === 0
  const buttonDisabled = chatInputIsEmpty || isSubmitting

  return (
    <div className="chat-message-input-field">
      <ChatInput
        name="chatMessageInput"
        type="text"
        placeholder={i18n.t('chat_message_input_placeholder')}
        value={chatInput}
        onChangeHandle={evt => setChatInput(evt.target.value)}
        onKeyDown={e => handleKeyPress(e)}
        isDisabled={isSubmitting}
      />

      <Button
        disabled={buttonDisabled}
        variant="primary"
        modifiers={['chat-submit-message']}
        testid="Chat_SendMessage"
        event={handleClick}
      >
        <ChatSubmitMessageIcon />
      </Button>
    </div>
  )
}

ChatMessageInputField.propTypes = {
  submitMessage: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
}

export default ChatMessageInputField
